// extracted by mini-css-extract-plugin
module.exports = {"dropWrp":"styles_dropWrp__2g4kH","dropCon":"styles_dropCon__1flDA"};